import axios from 'axios';
import router from '../router';

const state = {
// users state
  suppliers: []
};

const mutations = {
// users mutations
    SET_SUPPLIERS(state, suppliers) {
        state.suppliers = suppliers;
    }
};

const actions = {
  async fetchSuppliers({ commit }, { search }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
        throw new Error('No token found'); // Handle absence of token
    }
    
    try {
        const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
        const response = await axios.get(`${baseUrl}/suppliers`, {
            headers: { Authorization: `Bearer ${userToken}` },
            params: { search } // Include search parameter in request
        });
        commit('SET_SUPPLIERS', response.data); // Update Vuex store with users
    } catch (error) {
        console.error('Error fetching locations:', error); // Log any errors
        throw error; // Handle error in your components
    }
  },
  async getSupplierByID({ commit }, supplierId) { // Change from destructuring to direct variable
    console.log('Fetching supplier with ID:', supplierId);
    const userToken = localStorage.getItem('userToken'); 
    if (!userToken) {
        router.push({ name: 'login' });
        return;
    }

    try {
        const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
        const response = await axios.get(`${baseUrl}/supplier/${supplierId}`, {
            headers: { Authorization: `Bearer ${userToken}` }
        });
        console.log('Supplier fetch response:', response.data);
        commit('SET_SUPPLIERS', response.data);
    } catch (error) {
        console.error('Error fetching supplier:', error);
        throw error;
    }
  },
  async createSupplier({ dispatch }, { supplier }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      await axios.post(`${baseUrl}/suppliers`, supplier, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      console.log('Supplier created:', supplier);
      dispatch('fetchSuppliers', { search: '' });
    } catch (error) {
      console.error('Error creating supplier:', supplier);
      throw error; // rethrow for component to handle
    }
  },
  async updateSupplier({ dispatch }, { supplier }) {
    console.log('Updating supplier:', supplier);
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
        await axios.put(`${baseUrl}/suppliers/${supplier.id}`, supplier,
          { headers: { Authorization: `Bearer ${userToken}` } }
        );
        console.log('Supplier updated:', supplier);
        dispatch('fetchSuppliers', { search: '' });
      } catch (error) {
        console.error('Error updating supplier:', supplier);
        throw error;
      }
  },
  async deleteSupplier({ dispatch }, { supplier }) {
    console.log('Deleting supplier:', supplier);
    const userToken = localStorage.getItem('userToken');
    console.log('User token:', userToken);
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      await axios.delete(`${baseUrl}/suppliers/${supplier}`,
        { headers: { Authorization: `Bearer ${userToken}` } }
      );
      console.log('Supplier deleted:', supplier);
      dispatch('fetchSuppliers', { search: '' });
    } catch (error) {
      console.error('Error deleting location:', error);
      throw error;
    }
  }  
};

const getters = {
// users getters
};
    
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};